import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="uploadGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#667eea" />
              <stop offset="100%" stopColor="#764ba2" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#uploadGradient)" fillOpacity="0.1"/>
          <path d="M24 16v16m-8-8l8-8 8 8M16 36h16" stroke="url(#uploadGradient)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Drag & Drop Upload",
      description: "Simply drag your files into the upload area or click to browse. Supports multiple file selection for batch processing."
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="formatGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4facfe" />
              <stop offset="100%" stopColor="#00f2fe" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#formatGradient)" fillOpacity="0.1"/>
          <rect x="12" y="12" width="24" height="16" rx="2" stroke="url(#formatGradient)" strokeWidth="2" fill="none"/>
          <circle cx="18" cy="20" r="2" fill="url(#formatGradient)"/>
          <path d="M22 24l4-4 8 8" stroke="url(#formatGradient)" strokeWidth="2" fill="none" strokeLinecap="round"/>
          <rect x="16" y="30" width="16" height="6" rx="1" fill="url(#formatGradient)" fillOpacity="0.3"/>
        </svg>
      ),
      title: "15+ File Formats",
      description: "Convert images (JPG, PNG, GIF), documents (DOC, DOCX), spreadsheets (XLS, XLSX), and more to PDF format."
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="batchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#fa709a" />
              <stop offset="100%" stopColor="#fee140" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#batchGradient)" fillOpacity="0.1"/>
          <rect x="10" y="10" width="12" height="16" rx="2" stroke="url(#batchGradient)" strokeWidth="1.5" fill="none"/>
          <rect x="14" y="14" width="12" height="16" rx="2" stroke="url(#batchGradient)" strokeWidth="1.5" fill="none"/>
          <rect x="18" y="18" width="12" height="16" rx="2" stroke="url(#batchGradient)" strokeWidth="1.5" fill="none"/>
        </svg>
      ),
      title: "Batch Processing",
      description: "Process multiple files simultaneously and choose to merge them into a single PDF or convert each file individually."
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="speedGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#a8edea" />
              <stop offset="100%" stopColor="#fed6e3" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#speedGradient)" fillOpacity="0.1"/>
          <circle cx="24" cy="24" r="12" stroke="url(#speedGradient)" strokeWidth="2" fill="none"/>
          <path d="M24 16v8l4 4" stroke="url(#speedGradient)" strokeWidth="2" fill="none" strokeLinecap="round"/>
          <circle cx="36" cy="12" r="3" fill="url(#speedGradient)"/>
        </svg>
      ),
      title: "Lightning Fast",
      description: "Advanced processing algorithms ensure quick conversion times while maintaining high quality output for all your files."
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="secureGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ffecd2" />
              <stop offset="100%" stopColor="#fcb69f" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#secureGradient)" fillOpacity="0.1"/>
          <rect x="16" y="20" width="16" height="12" rx="2" stroke="url(#secureGradient)" strokeWidth="2" fill="none"/>
          <path d="M20 20v-4a4 4 0 018 0v4" stroke="url(#secureGradient)" strokeWidth="2" fill="none"/>
          <circle cx="24" cy="26" r="2" fill="url(#secureGradient)"/>
        </svg>
      ),
      title: "100% Secure",
      description: "All file processing happens locally in your browser. Your files never leave your device, ensuring complete privacy."
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48">
          <defs>
            <linearGradient id="qualityGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#d299c2" />
              <stop offset="100%" stopColor="#fef9d7" />
            </linearGradient>
          </defs>
          <rect width="48" height="48" rx="12" fill="url(#qualityGradient)" fillOpacity="0.1"/>
          <polygon points="24,8 28,18 40,18 31,26 35,38 24,31 13,38 17,26 8,18 20,18" stroke="url(#qualityGradient)" strokeWidth="2" fill="none"/>
          <circle cx="24" cy="24" r="3" fill="url(#qualityGradient)"/>
        </svg>
      ),
      title: "High Quality Output",
      description: "Maintain original document quality with customizable compression settings and format-specific optimization."
    }
  ];

  return (
    <section id="features" className="features">
      <div className="landing-container-full">
        <div className="section-header">
          <h2 className="section-title">Powerful Features</h2>
          <p className="section-description">
            Everything you need to convert your files to PDF format quickly and efficiently
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="features-highlight">
          <div className="highlight-content">
            <h3>Ready to get started?</h3>
            <p>Join thousands of users who trust our PDF converter for their daily document needs.</p>
            <button className="btn btn-primary" onClick={() => window.location.hash = '#converter'}>
              Start Converting Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;